import React, { useEffect, useState } from "react";

import ReactCountryFlag from "react-country-flag";

import { Grid, Switch } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import "./LanguageSwitch.scss";

export const LanguageSwitch = () => {
  //Hooks
  const { i18n } = useTranslation();

  //State
  const [language, setLanguage] = useState(i18n.language);

  //Options
  const handleChange = (event: any) => {
    const isDe = event.target.checked;
    if (isDe) {
      i18n.changeLanguage("de");
    } else {
      i18n.changeLanguage("en");
    }
  };

  //Actions
  useEffect(() => {
    setLanguage(i18n.language);
  }, [i18n.language]);

  const getCountryCode = (lang: string) => {
    switch (lang) {
      case "en":
        return "US";
      case "de":
        return "DE";
      default:
        return "DE";
    }
  };

  return (
    <Grid
      component="label"
      container
      alignItems="center"
      spacing={0}
      justify="flex-end"
      className="language-switch"
    >
      <ReactCountryFlag
        svg
        countryCode={getCountryCode(language)}
        className="flag"
      />

      <Grid item>
        <Switch
          size="small"
          checked={language === "de"}
          color="default"
          inputProps={{ "aria-label": "checkbox with default color" }}
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
};
